import { Flex, QuickFilterChip } from '@elementary/common-ui/components';
import { CircularProgress } from '@mui/material';
import {
  DependenciesFilterOptions,
  DependenciesFiltersCounters,
} from '../types';

const filterOptions = [
  { label: 'All', value: DependenciesFilterOptions.All },
  { label: 'With access', value: DependenciesFilterOptions.WithAccess },
  { label: 'Upstream tables', value: DependenciesFilterOptions.Upstream },
  { label: 'Downstream tables', value: DependenciesFilterOptions.Downstream },
  {
    label: 'Downstream BI assets',
    value: DependenciesFilterOptions.DownstreamBIAssets,
  },
  { label: 'Critical assets', value: DependenciesFilterOptions.CriticalAssets },
];

type Props = {
  filter: string;
  setFilter: React.Dispatch<React.SetStateAction<string>>;
  counters: DependenciesFiltersCounters;
  isLoading?: boolean;
};

const DependenciesFilterRow = ({
  filter,
  setFilter,
  counters,
  isLoading,
}: Props) => (
  <Flex sx={{ flexWrap: 'wrap', gap: 2, paddingRight: 10 }}>
    {filterOptions.map((option) => (
      <QuickFilterChip
        key={option.value}
        value={option.value}
        label={
          isLoading ? (
            <Flex sx={{ alignItems: 'center', gap: 1 }}>
              {option.label}
              <CircularProgress size={12} />
            </Flex>
          ) : (
            `${option.label} (${counters?.[option.value] || 0})`
          )
        }
        filter={filter}
        onClick={setFilter}
        disabled={isLoading}
      />
    ))}
  </Flex>
);

export default DependenciesFilterRow;
